import type { ReactNode } from 'react';
import { Card, CardHeader, CardBody } from '@/components/ui/Card';

/** Titled container for a chart, with an optional right-aligned control slot. */
export function ChartCard({ title, description, actions, children }: {
  title: string; description?: string; actions?: ReactNode; children: ReactNode;
}) {
  return (
    <Card>
      <CardHeader title={title} description={description} actions={actions} />
      <CardBody>{children}</CardBody>
    </Card>
  );
}
